import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitContact = async (data) => {
  const res = await axios.post(`${API}/contact`, data);
  return res.data;
};

export const bookDemo = async (data) => {
  const res = await axios.post(`${API}/demo-bookings`, data);
  return res.data;
};

export const getBookedSlots = async (demoDate) => {
  const res = await axios.get(`${API}/demo-bookings/booked`, { params: { demo_date: demoDate } });
  return res.data;
};
